// DocumentComponent.jsx
import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Image, Font } from '@react-pdf/renderer';
import sitlogo from '../assets/images/sitlogo.png'
import { BASE_URL } from './BaseUrl';

import axios from 'axios';
// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10,
        fontFamily: 'Helvetica',
        color: "lightslategrey",
        border: '1px solid black',
        borderColor: 'black',
        borderWidth: 1,
        borderStyle: 'solid round',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        // borderBottom: '1px solid #000',
        marginTop: 10,
        paddingBottom: 10,
        marginBottom: 20,
        header1: {
            Alignitems: 'center',
        },
    },
    headerLeft: {
        textAlign: 'left',
        flex: "3"
    },
    image: {
        height: 40,
        width: 80,
    },
    headerRight: {
        textAlign: 'center',

        flex: "13"
    },

    billTo: {
        marginBottom: 15,
        fontSize: 12,
        fontWeight: 'bold',
    },
    Course: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 10,
        marginTop: -10,


    },
    courseleft: {
        display: 'flex',
        flexDirection: 'row',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '3',
    },
    courseright: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '7',

    },
    coursecenter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '9',
    },
    itemsTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: 20,
    },
    Course1: {
        display: 'flex',
        flexDirection: 'row',
        borderBottom: '1px solid black'
        // marginBottom: 10,
        // marginTop: -10,


    },
    rowText: {
        color: '#000',
        fontWeight: "900",
        fontSize: "10px",
        padding: 3
    },
    row1: {
        // flexDirection: 'row',

    },
    row2: {
        // flexDirection: 'row',

    },
    row3: {
        // flexDirection: 'row',

    },
    row4: {
        // flexDirection: 'row',

    },
    row5: {
        // flexDirection: 'row',

    },
    col1: {
        flexDirection: 'row',
        // justifyContent: 'space-between', // or 'flex-start', 'center'
        alignItems: 'center',            // vertically center rows
        // padding: 5,
        borderBottom: 1,
        borderColor: '#000',
        // marginBottom: 10,
    },
    tableCellHeader: {

        padding: 8,
        fontWeight: '700',
        width: '50%',
        alignItems: 'center',
        marginLeft: '200px',
    },
    tableCell: {

        padding: 8,
        width: '20%',
    },
    totals: {
        marginBottom: 20,
    },
    footer1: {
        display: 'flex',
        marginBottom: 10,
        margintop: 10,
        flexDirection: 'row',

    },
    footer: {
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'row',
    },
    footer3: {
        position: 'fixed',
        bottom: 0,
        display: 'flex',
        flexDirection: 'row',
    },
    footer4: {
        position: 'fixed',
        top: 487,
        bottom: 0,
        display: 'flex',
        flexDirection: 'row',
    },
    signatory: {
        textAlign: 'right',
        marginTop: 40,
    },
});

const SiteVisitReport
    = ({ data }) => {
        const studentList = Array.isArray(data) ? data : [];

        function formatDate(dateInput) {
            const date = new Date(dateInput);
            const day = String(date.getDate()).padStart(2, '0');        // dd
            const month = String(date.getMonth() + 1).padStart(2, '0'); // mm (months are 0-indexed)
            const year = date.getFullYear();                            // yyyy

            return `${day}-${month}-${year}`;
        }

        function formatDate2(dateInput) {
            const date = new Date(dateInput);
            const day = String(date.getDate()).padStart(2, '0');       // 06
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];                 // Aug
            const year = date.getFullYear();                           // 2014

            return `${day}-${month}-${year}`;
        }




        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.header}>
                        <View style={styles.headerLeft}>
                            <Image src={sitlogo} style={styles.image} />
                        </View>

                        <View style={styles.headerRight}>
                            <Text style={{ fontSize: '13px', fontWeight: '800', color: "#000" }}></Text>
                        </View>
                    </View>
                    <View style={[styles.Course, {
                        borderWidth: 1,
                        borderColor: '#000',
                        padding: 5,
                        marginBottom: 10, // optional spacing
                        borderRadius: 4   // optional rounded corners
                    }]}>
                        <View style={styles.courseright}>
                            <Text style={{ fontSize: 9, fontWeight: '300', color: "#000" }}></Text>
                        </View>
                        <View style={styles.coursecenter}>
                            <Text style={{ fontSize: 9, fontWeight: '300', color: "#000", marginLeft: '28px' }}>SITE VISIT CONFIRMATION</Text>
                        </View>
                        <View style={styles.courseleft}>
                            <Text style={{ fontSize: 15, fontWeight: '300', color: "#000" }}></Text>
                        </View>
                    </View>
                    <View style={{ border: "2px solid black", height: "80%" }}>

                        <View style={styles.col1}>
                            <View style={[styles.row4, { width: '15%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Batch No </Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>            </Text>
                            </View>
                            <View style={[styles.row4, { width: '35%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Training Programme</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>            </Text>
                            </View>
                            <View style={[styles.row4, { width: '18%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Date of Visit</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>             </Text>
                            </View>
                            <View style={[styles.row4, { width: '18%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Reporting Time </Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Sit,Santacruz</Text>
                            </View>
                            <View style={[styles.row4, { width: '14%' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Date</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>          </Text>
                            </View>

                        </View>
                        <View style={styles.col1}>
                            <View style={[styles.row4, { width: '15%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>{studentList[0].Batch_Code}</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>             </Text>
                            </View>
                            <View style={[styles.row4, { width: '35%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>{studentList[0].Course_Name}</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>             </Text>
                            </View>
                            <View style={[styles.row4, { width: '18%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}> {formatDate(studentList[0]?.Visit_Date)}</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>             </Text>
                            </View>
                            <View style={[styles.row4, { width: '18%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Confirmation </Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>acquired on </Text>
                            </View>
                            <View style={[styles.row4, { width: '14%' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}> {formatDate2(studentList[0]?.ConfirmDate)}</Text>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>             </Text>
                            </View>

                        </View>
                        <View style={styles.Course1}>
                            <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, marginTop: 3, color: "#000" }}>Site Location :- {studentList[0].Location}</Text>
                        </View>
                        <View style={styles.col1}>
                            <View style={[styles.row4, { width: '15%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>ID No.</Text>
                            </View>
                            <View style={[styles.row4, { width: '45%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Student Name </Text>
                            </View>
                            <View style={[styles.row4, { width: '20%', borderRight: '1px solid black' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Confirmation</Text>
                            </View>
                            <View style={[styles.row4, { width: '20%' }]}>
                                <Text style={{ fontWeight: "900", fontSize: "10px", padding: 3, color: "#000" }}>Signature</Text>
                            </View>
                        </View>

                        {/* Table Headers */}


                        {/* Dynamic rows */}
                        {studentList.map((item, index) => (
                            <View style={styles.col1} key={index}>
                                <View style={[styles.row4, { width: '15%', borderRight: '1px solid black' }]}>
                                    <Text style={styles.rowText}>{item.Student_Code}</Text>
                                </View>
                                <View style={[styles.row4, { width: '45%', borderRight: '1px solid black' }]}>
                                    <Text style={styles.rowText}>{item.Student_Name}</Text>
                                </View>
                                <View style={[styles.row4, { width: '20%', borderRight: '1px solid black' }]}>
                                    <Text style={styles.rowText}> </Text>
                                </View>
                                <View style={[styles.row4, { width: '20%' }]}>
                                    <Text style={styles.rowText}> </Text>
                                </View>
                            </View>
                        ))}



                    </View>
                    <View style={(styles.footer3)}>
                        <Text style={{ lineHeight: "1.2", marginLeft: '5px', color: '#000', marginTop: '10px', fontSize: '8px' }}> F/CB/02/00</Text>
                        <Text style={{ lineHeight: "1.2", marginLeft: '40px', color: '#000', marginTop: '10px', fontSize: '6px', marginRight: '1px', }}>                                                                                                                                                            </Text>
                        <Text style={{ lineHeight: "1.2", marginLeft: '113px', color: '#000', marginTop: '10px', fontSize: '8px', marginRight: '10px' }}>1</Text>
                    </View>
                </Page>
            </Document>
        )

    };



export default SiteVisitReport

